/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// import { XMarkIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'

import GalleryLoading from "../../components/shared/GalleryLoading";
// import galleryConfigss from "../../constant/gallery";
import fetchGallery from "../../helper/getGallery";

import EffectSplatter from "../../assets/images/effect-splatter.png";
import PageHeadline from "../../components/shared/PageHeadline";
import ComingSoon from "../../components/shared/ComingSoon";

export default function Index() {
    const { t } = useTranslation();
    const locale = useSelector((state) => state.locale.locale);

    const CT2026 = "CT2026";
    const PY2026 = "PY2026";
    const RD2026 = "RD2026";

    const [galleryConfigs, setGalleryConfigs] = useState({
        [CT2026]: { eventName: "City Touchdown Surabaya 2026", locations: [] },
        [PY2026]: { eventName: "suroboyo10k 2026 project you", locations: [] },
        [RD2026]: {
            eventName: "Suroboyo 10K 2026",
            locations: [
                "START",
                "FINISH",
                "URIP SUMOHARJO",
                "EMBONG MALANG",
                "BUBUTAN",
                "GENTENG KALI",
                "NGEMPLAK"
            ]
        },
    });

    const [configLoaded, setConfigLoaded] = useState(true);

    const [galleryData, setGalleryData] = useState([]);
    const [totalGalleryData, setTotalGalleryData] = useState(null);

    const [isLoading, setLoading] = useState(false);
    const [activeYear, setActiveYear] = useState(CT2026);
    const [configSelected, setConfigSelected] = useState(null);
    const [locationOption, setLocationOption] = useState([]);
    const [activeLocation, setActiveLocation] = useState("");

    // Update configSelected when gallery configs are loaded
    useEffect(() => {
        if (galleryConfigs && galleryConfigs[activeYear] && galleryConfigs[activeYear].eventName) {
            setConfigSelected(galleryConfigs[activeYear]);
            setLocationOption(galleryConfigs[activeYear].locations);
        } else {
            setConfigSelected(null);
            setLocationOption([]);
        }
    }, [galleryConfigs, activeYear]);

    // eslint-disable-next-line no-unused-vars
    const [pageNumber, setPageNumber] = useState(1);
    const [inputValue, setInputValue] = useState(""); // Menyimpan value langsung dari input
    const [endOfPage, setEndOfPage] = useState(false);
    const [isComingSoon, setIsComingSoon] = useState(false);

    // Debounced search value
    const [debouncedValue, setDebouncedValue] = useState("");

    const btnClassYear =
        "!text-mutedGrey px-6 py-3 rounded-lg hover:!text-primary transition-all duration-300 text-white";

    const btnClass =
        "px-4 py-2 bg-mutedGrey/50 rounded-lg hover:bg-primary hover:!text-white transition-all duration-500 !text-primary font-bold";

    const switchYear = async (year) => {
        setPageNumber(1);
        setGalleryData([]);
        setTotalGalleryData(null);
        setActiveYear(year);
        setInputValue("");
        setDebouncedValue("");
        setEndOfPage(false);
        setActiveLocation("");

        if (year === RD2026) {
            setIsComingSoon(false);
        } else {
            setIsComingSoon(false);
        }
    };

    const switchLocation = (value) => {
        setPageNumber(1);
        setGalleryData([]);
        setEndOfPage(false);
        setActiveLocation(value);
    };

    const handleChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        // Clear gallery data immediately when typing
        if (newValue !== debouncedValue) {
            setGalleryData([]);
        }
        setEndOfPage(false);
        setPageNumber(1);
    };

    // Define debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    // Create a memoized version of the scroll handler
    const debouncedHandleScroll = useMemo(() =>
        debounce(() => {
            if (document.body.scrollHeight - 500 < window.scrollY + window.innerHeight) {
                // Only proceed if we have data and haven't reached the end
                if (galleryData.length > 0 && !isLoading && !endOfPage) {
                    // Check if we've loaded all available data
                    if (totalGalleryData && galleryData.length >= totalGalleryData) {
                        setEndOfPage(true);
                    } else {
                        // Only fetch more data if we haven't loaded everything
                        setPageNumber(prevPage => prevPage + 1);
                    }
                }
            }
        }, 300),
        [galleryData.length, totalGalleryData, isLoading, endOfPage]
    );

    // Add and remove scroll event listener with cleanup
    useEffect(() => {
        window.addEventListener("scroll", debouncedHandleScroll);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener("scroll", debouncedHandleScroll);
        };
    }, [debouncedHandleScroll]);

    // Debounce the search input
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (inputValue !== debouncedValue) {
                setDebouncedValue(inputValue);
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [inputValue, debouncedValue]);

    useEffect(() => {
        let active = true;

        const fetchData = async () => {
            if (endOfPage) return;

            // Don't fetch if eventName is not available yet
            if (!configSelected || !configSelected.eventName) {
                return;
            }

            setLoading(true);

            try {
                const response = await fetchGallery(
                    configSelected.eventName,
                    activeLocation,
                    pageNumber,
                    debouncedValue
                );

                if (!active) return;

                if (response === null || !response.data || response.status?.error) {
                    setGalleryData([]);
                    setTotalGalleryData(0);
                    setEndOfPage(true);
                } else {
                    setTotalGalleryData(response.status.totalRecords);

                    // If no data received, mark as end of page
                    if (response.data.length === 0) {
                        setEndOfPage(true);
                    } else if (pageNumber === 1) {
                        // Replace data on first page
                        setGalleryData(response.data);
                        // If we got less data than total, we're at the end
                        if (response.data.length >= response.status.totalRecords) {
                            setEndOfPage(true);
                        }
                    } else {
                        // Append data for pagination
                        setGalleryData(currentData => {
                            const newData = [...currentData];
                            response.data.forEach(item => {
                                if (!newData.some(existing => existing.id === item.id)) {
                                    newData.push(item);
                                }
                            });
                            // If we've loaded all data, mark as end of page
                            if (newData.length >= response.status.totalRecords) {
                                setEndOfPage(true);
                            }
                            return newData;
                        });
                    }
                }
            } catch (error) {
                console.error("Error fetching gallery data:", error);
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        if (configLoaded) {
            fetchData();
        }

        return () => {
            active = false;
        };
    }, [configSelected, activeLocation, pageNumber, debouncedValue, configLoaded]);

    //Repush gallery

    return (
        <div className="bg-white relative">
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("galleryTitle")} />
            </div> */}
            <div className="flex mx-auto px-4 items-start justify-start z-10 min-h-screen 2xl:pt-56 md:pt-40 pt-24 w-full bg-white bg-no-repeat">
                <div className="2xl:px-0 md:px-14 px-4 w-full py-4">
                    <div className="w-full font-poppins text-primary relative overflow-hidden">
                        <img
                            src={EffectSplatter}
                            alt="Decorative splatter effect"
                            className="pointer-events-none absolute top-64 md:top-96 left-96 object-contain opacity-50 select-none z-[1]"
                        />
                        <div className="container h-full mx-auto w-full z-50">
                            <div className="w-full mb-8">
                                <div className="space-y-4">
                                    <div className="space-y-4 flex max-md:flex-wrap">
                                        <div className="basis-full md:basis-4/12">
                                            <div className={`text-9xl font-wantCoffee text-primary`}>{t("gallery.title")}</div>
                                        </div>
                                        <div className="basis-full md:basis-8/12 h-full space-y-4">
                                            <div className="flex md:flex-row flex-col items-center justify-between md:gap-y-0 gap-y-6">
                                                <h1 className="2xl:text-5xl text-3xl uppercase font-bold max-w-2xl italic font-roboto">
                                                    Race Gallery
                                                </h1>
                                                <div className="max-md:w-full max-md:flex max-md:justify-end max-md:gap-x-4 md:space-x-4">
                                                    <button
                                                        onClick={() => switchYear(CT2026)}
                                                        className={`text-lg font-roboto ${btnClassYear} ${activeYear === CT2026 ? "!text-primary font-bold" : null
                                                            }`}
                                                    >
                                                        City Touchdown
                                                    </button>
                                                    <button
                                                        onClick={() => switchYear(PY2026)}
                                                        className={`text-lg font-roboto ${btnClassYear} ${activeYear === PY2026 ? "!text-primary font-bold" : null
                                                            }`}
                                                    >
                                                        Project You
                                                    </button>
                                                    <button
                                                        onClick={() => switchYear(RD2026)}
                                                        className={`text-lg font-roboto ${btnClassYear} ${activeYear === RD2026 ? "!text-primary font-bold" : null
                                                            }`}
                                                    >
                                                        Race Day
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="md:px-0 px-6">
                                                <input
                                                    id="name"
                                                    name="name"
                                                    type="text"
                                                    className="bg-primary/50 block border w-full 2xl:py-6 2xl:px-6 px-4 py-2 rounded-lg placeholder:text-white text-white z-10"
                                                    placeholder="Search your BIB here"
                                                    value={inputValue}
                                                    onChange={handleChange}
                                                    disabled={isComingSoon}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-wrap justify-center gap-4 md:px-0 px-2 font-roboto z-10">
                                        {console.log("locationOption", locationOption)}
                                        {!isComingSoon &&
                                            locationOption.map((value, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => {
                                                        if (activeLocation === value) {
                                                            switchLocation("")
                                                        } else {
                                                            switchLocation(value)
                                                        }
                                                    }}
                                                    className={`${btnClass} text-xs ${activeLocation === value
                                                        ? "bg-brandYellow !text-primary"
                                                        : null
                                                        }`}
                                                >
                                                    {value}
                                                </button>
                                            ))}
                                    </div>
                                    <div className="flex flex-wrap justify-center gap-4 md:px-0 px-2 font-bold text-sm font-roboto z-10">
                                        {totalGalleryData === 0 && !isComingSoon && inputValue != "" && <span>Image not found with specified keyword.</span>}
                                        {!isComingSoon && <span>{totalGalleryData} photo(s) uploaded.</span>}
                                    </div>
                                    <div className="p-5 sm:p-8">
                                        {isComingSoon ? (
                                            <h1 className="text-center font-bold italic lg:text-7xl">
                                                Coming Soon
                                            </h1>
                                        ) : (
                                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 md:grid-cols-3 lg:grid-cols-4">
                                                <Gallery options={{
                                                    padding: { top: 20, bottom: 40, left: 10, right: 10 },
                                                }}>
                                                    {galleryData.map((item, index) => {
                                                        let metaWidth = JSON.parse(item.mftgMeta) && JSON.parse(item.mftgMeta).width ? Math.round(JSON.parse(item.mftgMeta).width / 5) : 600;

                                                        return (
                                                            <div className="rounded-lg" key={index}>
                                                                <Item key={index} original={item.mftgUrl} thumbnail={`${item.mftgUrl}/width/${metaWidth}`} width={JSON.parse(item.mftgMeta).width} height={JSON.parse(item.mftgMeta).height}>
                                                                    {({ ref, open }) => (
                                                                        <img ref={ref} onClick={open} src={`${item.mftgUrl}/width/${metaWidth}`} alt={item.mftgDescription} className="rounded-lg cursor-zoom-in" />
                                                                    )}
                                                                </Item>
                                                            </div>
                                                        )
                                                    }
                                                    )}
                                                </Gallery>
                                                {isLoading === true && endOfPage === false && <GalleryLoading />}
                                            </div>
                                        )}
                                    </div>
                                    {endOfPage && totalGalleryData > 0 && <p className="text-center font-bold text-lg">You have reach the end of page.</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
